export default {"src":"/_next/static/media/coloredLogo.58219496.svg","height":55,"width":51,"blurWidth":0,"blurHeight":0};